import React, { memo } from 'react'

import { Icon, Add, classnames } from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { func } from 'prop-types'

import { useLocation } from 'Pods/Shared/ContextBasedRouter'
import useGenerateNewModel, {
  isNewModelPage,
} from 'Pods/ThreeDStudio/Components/Sidebar/Components/LibraryContent/Hooks/useGenerateNewModel'
import { iconSizeMedium } from 'Pods/ThreeDStudio/constants'
import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

function NewModelCard({ onNavigate }) {
  const t = useTranslation()
  const location = useLocation()
  const isActive = isNewModelPage(location)
  const handleClick = useGenerateNewModel(onNavigate)

  return (
    <div
      className={classnames(
        'model-card',
        'model-card--action',
        'model-card--new',
        isActive && 'model-card--active'
      )}
      onClick={handleClick}
    >
      <div className="model-card__action">
        <Icon svgComponent={Add} size={iconSizeMedium} color="dark" notSpaced />
        <span className="model-card__action-text">
          {t('sidebar.newModelCard.titleLine1')}
          <br/>
          {t('sidebar.newModelCard.titleLine2')}
        </span>
      </div>
    </div>
  )
}

NewModelCard.propTypes = {
  onNavigate: func.isRequired,
}

export default memo(NewModelCard)
